const storage = window.localStorage;
const storageNamespace = 'PerformancePortalService';

const Storage = {
  getItem: (item: string): string | null => {
    return storage.getItem(`${storageNamespace}_${item}`);
  },

  setItem: (item: string, value: string): void => {
    storage.setItem(`${storageNamespace}_${item}`, value);
  },

  removeItem: (item: string): void => {
    storage.removeItem(`${storageNamespace}_${item}`);
  },
};

export default Storage;
